import { init as nl__init } from "./init.js";
import { init as lenis__init } from "./modules/lenis.js";
import { init as barba__init } from "./modules/barba.js";
import { init as hooks__init } from "./modules/hooks.js";

barba__init();
lenis__init();
hooks__init();

jQuery(function () {  
       //console.log('jQuery first time');
       nl__init();        
       
});


